import React from "react";
import classes from "./popup.module.scss";
import PrimaryButton from "../button/PrimaryButton";
import Image from "../Image/Image";
import { useAppContent } from "../../../shared/AppContent";
import { useSelector } from "react-redux";
import { getOracleCTAClick } from "../../../shared/AdobeUtility";
const Popup = (props) => {
  const currentAppState = useSelector((state) => state.AppState);
  const { closeJourneyContent, changeCardContent } = useAppContent();
  return (
    <div className={classes[props.popupStyle]}>
      <div className={props.isCustom ? props.PopupBox : classes.PopupBox}>
        <div className={props.isCustom ? props.Box : classes.Box}>
          {props.isCustom ? (
            props.header
          ) : (
            <>
              {props.hideCloseButton ? "" :
                <span className={classes.CloseIcon} onClick={props.retryPayment ? props.closeBtn : props.handleClose}>
                  <Image filename={"Path1221"} ext={"png"} renditions={["2x"]} />
                </span>}
            </>
          )}
          <div className={props.personalDetailsBody ? props.personalDetailsBody : classes.personalDetailsBody}>
            {props.content}
            {props.buttonLabel && (
              <div className={props.isCustom ? props.CloseBtn : classes.CloseBtn}>
                <PrimaryButton
                  label={props.buttonLabel}
                  filename={props.filename}
                  renditions={props.renditions}
                  ext={props.ext}
                  handleClick={() => {
                    props.handleClose();
                    getOracleCTAClick("exit-popup", currentAppState, "Continue to apply");
                  }}
                  className={props.isCustom ? props.closePrimaryButton : classes.ctnBTN}

                />
              </div>
            )}
          </div>
          {props.exitApply && <div onClick={() => {
            props.exit(); getOracleCTAClick("exit-popup", currentAppState, "Exit apply journey")
          }} className={classes.exitButton}>{closeJourneyContent.exitButton}</div>}
          {props.cancel && <div className={props.isCustom ? props.CancelBtn : ""} onClick={() => {
            props.handleCancel(); getOracleCTAClick("exit-popup", currentAppState, "Cancel apply journey")
          }}>{changeCardContent?.change_card_page?.cancelTxt}</div>}
        </div>
      </div>
    </div>
  );
};

export default Popup;
